var React = require('react');

function Increase (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M163.5,302.4c-2,2-4.9,3.3-8,3.3c-6.2,0-11.3-5-11.3-11.3V16.6c0-6.2,5-11.3,11.3-11.3s11.3,5,11.3,11.3v277.8\n\tC166.8,297.5,165.6,300.3,163.5,302.4z","key":0}),React.createElement("path",{"d":"M302.4,163.5c-2,2-4.9,3.3-8,3.3l-277.8,0c-6.2,0-11.3-5-11.3-11.3c0-6.2,5-11.3,11.3-11.3l277.8,0c6.2,0,11.3,5,11.3,11.3\n\tC305.7,158.6,304.5,161.4,302.4,163.5z","key":1})]);
}

Increase.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 311 311","style":{"enableBackground":"new 0 0 311 311"},"xmlSpace":"preserve"};

module.exports = Increase;

Increase.default = Increase;
